import { Controller } from "stimulus"
import { showTarget, hideTarget } from '../../helpers/visibility'

export default class extends Controller {
  static targets = [
    "pullEvents",
    "blockAvailability",
    "blockAvailabilityWrapper",
    "enforceBuffer",
    "enforceBufferWrapper",
    "syncFromCalendarWrapper",
    "pushEvents",
    "syncToCalendarWrapper"

  ]

  connect() {
    this.updateVisibility()
  }

  updateVisibility() {
    if(this.hasPullEventsTarget) {
      this.updatePullVisibility()
    }

    if(this.hasPushEventsTarget) {
      this.updatePushVisibility()
    }
  }

  updatePullVisibility() {
    if(this.pullEventsTarget.checked) {
      showTarget(this.blockAvailabilityWrapperTarget)
      showTarget(this.syncFromCalendarWrapperTarget)

      if(this.blockAvailabilityTarget.checked) [
        showTarget(this.enforceBufferWrapperTarget)
      ]
      else {
        hideTarget(this.enforceBufferWrapperTarget)
      }
    }
    else {
      hideTarget(this.blockAvailabilityWrapperTarget)
      hideTarget(this.enforceBufferWrapperTarget)
      hideTarget(this.syncFromCalendarWrapperTarget)
    }
  }

  updatePushVisibility() {
    if(this.pushEventsTarget.checked) {
      showTarget(this.syncToCalendarWrapperTarget)
    }
    else {
      hideTarget(this.syncToCalendarWrapperTarget)
    }
  }
}
